'use strict';

import 'superfish';
import 'mmenu-js';

const buildDesktopMenu = () => {
    $('.main-menu').superfish();
}

const buildMobileMenu = () => {
    const $body = $('body');
    const $mmenu = new Mmenu(document.querySelector('#mmenu'), {
        slidingSubmenus: false,
        offCanvas: {
            position: "right-front"
        },
        theme: 'light',
        navbar: {
            add: false
        },
        navbars: [
            {
                position: 'top',
                content: [
                    $('.mmenu-navbars > .navbar-top').html()
                ]
            },
            {
                position: 'bottom',
                content: [
                    $('.mmenu-navbars > .navbar-bottom').html()
                ]
            }
        ]
    }, {
        classNames: {
            selected: "current"
        },
        offCanvas: {
            clone: true,
            menu: {
                insertSelector: 'body'
            },
            page: {
                nodetype: '.global-container'
            }
        }
    });

    const mMenu = $mmenu.API;
    $('.menu-trigger, .mmenu-trigger').on('click', function () {
        if ($mmenu.hasClass('mm-menu_opened')) {
            $body.removeClass('mobile-menu-opened');
            mMenu.close();
        } else {
            $body.addClass('mobile-menu-opened');
            mMenu.open();
        }
        return false;
    });

    $('.mmenu-close').on('click', function () {
        $body.removeClass('mobile-menu-opened');
        mMenu.close();
    });
}

export default {buildDesktopMenu, buildMobileMenu}
